import { render, staticRenderFns } from "./TransverseColumn.vue?vue&type=template&id=99fb7802&scoped=true"
import script from "./TransverseColumn.vue?vue&type=script&lang=js"
export * from "./TransverseColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fb7802",
  null
  
)

export default component.exports